import { message, Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import { GetProfileDetails } from '../../../apis/Influencer/Profile/GetProfileDetails';
import { SettingsLists } from '../../../apis/Influencer/Profile/SettingsLists';
import { UpdateProfileDetails } from '../../../apis/Influencer/Profile/UpdateProfileDetails';
import { dispatch, useGlobalState } from '../../../store/state';
import ProfilePlatformsComponent from './ProfilePlatformsComponent';
import ProfileUserBasicsComponent from './ProfileUserBasicsComponent';
import ProfileUserInterestsComponent from './ProfileUserInterestsComponent';
import { useLocation } from 'react-router-dom';
import ProfileWalletComponent from './ProfileWalletComponent';
import './ProfileWidget.styles.scss';

import { ConnectTwitter } from '../../../apis/Influencer/Socials/ConnectTwitter';

function useQuery () {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}


const { TabPane } = Tabs;
const ProfileWidget = () => {
  const [user] = useGlobalState('user');
  const query = useQuery();
  const [tOauthData] = useGlobalState('tOauthData');
  const [currentTab, setCurrentTab] = useState(query.get('tab') ? `${query.get('tab')}`: '0');
  const [baseSettings, setBaseSettings] = useState({});


  const refreshProfile = () =>{
    console.log('getting refresh');
    GetProfileDetails(user.accessToken).then(({ response, status }) =>{
      console.log('getting data', response);
      if (status === 200) {
        dispatch({
          type: 'SET_USER',
          payload: {
            ...user,
            ...response,
          },
        });
      } else {
        message.error('There is some issue with getting your profile details');
      }
    });
  };
  const getBasicLists = () =>{
    SettingsLists(user.accessToken).then(({ response, status }) =>{
      console.log('getting base list data', response);
      if (status === 200) {
        setBaseSettings({
          ...baseSettings,
          ...response,
        });
        console.log('refresh after retrived base');
        // refreshProfile()
      } else {
        message.error('There is some issue with getting your Settings Data');
      }
    });
  };

  const connectingTwitter = () => {
    // @note: check if twitter aready there if there assign as completed
    if (user && user.twitter_account && user.twitter_account.enabled) {
      dispatch({
        type: 'SET_T_OAUTH',
        payload: {
          ...tOauthData,
          complete: true,
        },
      });
    }
    if (Object.keys(tOauthData).length > 1 && !tOauthData.complete) {
      const { oauthRequestToken, oauthRequestTokenSecret } = tOauthData.data;
      const { oauth_token, oauth_verifier, denied } = queryString.parse(window.location.search);
      console.log('oauth_token', oauth_token, 'oauth_verifier', oauth_verifier, 'denied', denied);
      if (oauth_verifier && oauthRequestToken && oauthRequestTokenSecret) {
        const _data = {
          oauthRequestToken: oauthRequestToken,
          oauthRequestTokenSecret: oauthRequestTokenSecret,
          oauthVerifier: oauth_verifier,
        };
        console.log('to setp 3 data', _data);
        ConnectTwitter(user.accessToken, _data).then(({ status, response })=>{
          console.log('status after auth', response);
          if (status === 200) {
            message.success('Twitter Connected Successfully!');
            dispatch({
              type: 'SET_T_OAUTH',
              payload: {
                ...tOauthData,
                complete: true,
              },
            });
            // @note: refresh user data
            refreshProfile();
            setCurrentTab(1);
          } else {
            message.error('There is some issue to connect your Twitter Account');
          }
        });
      } else {
        if (denied) {
          console.log('Twitter Linking Denied ID:', denied);
        }
      }
    } else {
      console.log('no Twitter Data Available');
    }
  };

  const updateProfile = (data) => {
    // console.log()
    UpdateProfileDetails(user.accessToken, data).then(({ status, response })=>{
      console.log('API: Reposne after basic profile update', response);
      if (status === 200) {
        message.success('Profile Details Updated');
        refreshProfile(); // refetch data in profile
      } else {
        message.error('There is some issue while updating profile');
      }
    });
  };


  useEffect(()=>{
    connectingTwitter();
    refreshProfile();
    getBasicLists();
  }, []);

  return (
    <div className="prof_widget px-3 pt-1 pb-3">
      {/* Profile Widget */}
      <Tabs activeKey={currentTab}
        size="small"
        onChange={(tab) => setCurrentTab(tab)}>
        <TabPane tab="My Profile"
          key="0">
          {
            Object.keys(baseSettings).length ?
              <ProfileUserBasicsComponent
                setCurrentTab={setCurrentTab}
                updateProfile={updateProfile}
                refreshProfile={refreshProfile}
                genderList={baseSettings.gender || []}
                cityList={baseSettings.locations || []}
                languages={baseSettings.language || []}
              />:
              null
          }
        </TabPane>
        <TabPane tab="Platforms"
          key="1">
          <ProfilePlatformsComponent
            refreshProfile={refreshProfile}
            setCurrentTab={setCurrentTab}
            connectingTwitter={connectingTwitter}
          />
        </TabPane>
        <TabPane tab="Interests"
          key="2">
          <ProfileUserInterestsComponent
            setCurrentTab={setCurrentTab}
            updateProfile={updateProfile}
            interests={baseSettings.topics || []}
          />
        </TabPane>
        {/* <TabPane tab="Wallet"
          key="3">
          <ProfileWalletComponent updateProfile={updateProfile}/>
        </TabPane> */}
      </Tabs>
    </div>
  );
};

export default ProfileWidget;
